export class IMasters {
  constructor() {
    this.master_option_id = null;
    this.name = null;
    this.label = null;
    this.slug = null;
    this.levels = null;
  }
}
